import React from "react";
import { Route } from "react-router";
import LoginPage from "pages/authentication/login";
import Register from "pages/authentication/register";
import Logout from "pages/authentication/logout";
import GuestRoute from "helpers/authentication/guestRoute";
import AuthRoute from "helpers/authentication/authRoute";

const AuthRoutes = () => (
    <>
        <Route
            path="/login"
            element={
                <GuestRoute>
                    <LoginPage />
                </GuestRoute>
            }
        />
        <Route
            path="/register"
            element={
                <GuestRoute>
                    <Register />
                </GuestRoute>
            }
        />
        <Route
            path="/logout"
            element={
                <AuthRoute>
                    <Logout />
                </AuthRoute>
            }
        />
    </>
);

export default AuthRoutes;
